import MonoFieldBase from '../base/MonoField';
import createField from './createField';

const MonoField = createField(MonoFieldBase);

export default MonoField;
